import { css, CSSObject } from '@emotion/react'
import { fonts, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const carouselWrapper = css({
  position: 'relative',
  width: '100%',
  backgroundColor: colors.n7.base,
  '&:hover': {
    '& .carousel-controls': {
      opacity: 1,
    },
  },
})

export const pageContainer = css({
  width: '100%',
  position: 'relative',
  minHeight: 300,
  height: 'var(--container-height, auto)',
})

export const pageLoading = css({
  'img, video': {
    opacity: 0,
  },
})

export const assetStyles: CSSObject = {
  width: '100%',
  position: 'relative',
  'img, video': {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
}

export const navigationWrapper = css({
  position: 'absolute',
  top: '50%',
  left: 0,
  right: 0,
  transform: 'translateY(-50%)',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 12px',
  pointerEvents: 'none',
  opacity: 0,
  transition: 'opacity 0.2s ease',
  zIndex: 1001,
})

export const navButtonOverride: CSSObject = {
  width: 32,
  height: 32,
  minWidth: 32,
  borderRadius: '50%',
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  border: 'none',
  padding: 0,
  pointerEvents: 'auto',
  '&:hover:not(:disabled)': {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  '&:disabled': {
    opacity: 0.4,
    cursor: 'default',
  },
  '.lapidary-icon': {
    color: 'white',
  },
}

export const pageIndicator = css({
  position: 'absolute',
  bottom: 12,
  left: 12,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  color: 'white',
  padding: '4px 10px',
  borderRadius: 4,
  fontSize: fontSizes.small,
  fontFamily: fonts.sourceCode,
  opacity: 0,
  transition: 'opacity 0.2s ease',
  zIndex: 1001,
})

export const documentHeader = css({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  padding: '12px 16px',
  opacity: 0,
  transition: 'opacity 0.2s ease',
  zIndex: 1001,
})

export const documentHeaderContent = css({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const documentTitleInput: CSSObject = {
  flex: 1,
  backgroundColor: 'transparent',

  '&:hover': {
    backgroundColor: 'transparent',
  },

  '.tiptap.ProseMirror': {
    padding: 0,
    color: 'white',
    fontSize: 16,
    fontWeight: 600,
  },

  '.tiptap p.is-editor-empty::before': {
    color: 'rgba(255, 255, 255, 0.5)',
  },
}

export const pageCountLabel = css({
  color: 'rgba(255, 255, 255, 0.8)',
  fontSize: 14,
  whiteSpace: 'nowrap',
})

export const emptyPlaceholder = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 336,
  backgroundColor: colors.n8.base,
  color: colors.n4.base,
  fontSize: 14,
})
